<template>
  <div>
    <Gmap-Map v-show="isShowMap" ref="map" style="width: 100%; height: 50vh" :zoom="7" :center="direct_from"> </Gmap-Map>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Map',
  props: {
    origin: {
      type: Object,
      default: () => {}
    },
    destination: {
      type: Object,
      default: () => {}
    },
    isShowMap: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      direct_from: {},
      direct_to: {},
      distance: 0,
      directionsService: null,
      directionsDisplay: null
    }
  },

  computed: {
    ...mapGetters({
      validGGApi: 'validGGApi'
    })
  },
  watch: {
    origin() {
      this.getDirection()
    },
    destination() {
      this.getDirection()
    },
    isShowMap(val) {
      if (val) {
        this.getDirection()
      }
    }
  },

  mounted() {
    this.initMap()
    window.gm_authFailure = () => {
      this.handleGoogleInvalid()
    }
  },

  methods: {
    initMap() {
      this.direct_from = this.origin
      this.direct_to = this.destination
      this.$refs.map.$mapPromise.then(() => {
        this.directionsService = new google.maps.DirectionsService()
        this.getDirection()
      })
    },

    handleGoogleInvalid() {
      // Distance is 0 in case google map invalid
      this.$emit('checkWalkingDistance', 0)
      this.$store.dispatch('updateGoogleApiStatus', false)
    },

    getDirection: async function () {
      if (this.directionsDisplay != null) {
        this.directionsDisplay.setMap(null)
        this.directionsDisplay = null
      }
      this.directionsDisplay = new google.maps.DirectionsRenderer()
      this.directionsDisplay.setMap(this.$refs.map.$mapObject)
      //google maps API's direction service
      function calculateAndDisplayRoute(directionsService, directionsDisplay, start, destination) {
        return new Promise((resolve, reject) => {
          let route = null
          if (!directionsService) return
          directionsService.route(
            {
              origin: start,
              destination: destination,
              travelMode: google.maps.TravelMode.WALKING
            },
            (response, status) => {
              if (status === 'OK') {
                directionsDisplay.setDirections(response)
                route = response.routes[0]
              }
              resolve(route)
            }
          )
        })
      }
      let distance = 0
      if (this.validGGApi) {
        let route = await calculateAndDisplayRoute(this.directionsService, this.directionsDisplay, this.origin, this.destination)
        if (!_.isEmpty(route)) {
          distance = route.legs[0].distance.value / 1000
        }
      }
      this.distance = distance
      this.$emit('checkWalkingDistance', this.distance)
    }
  }
}
</script>
